module.exports = __webpack_public_path__ + "static/media/questionType-img.e097b9d8.png";